//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrp4Menu', {
//        templateUrl: 'views/components/views/prodGrp4Menu/prodGrp4Menu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'prodGrp4MenuService', function ($stateParams, prodGrp4MenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrp4Id = $stateParams.prodgrp4_id;

//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await prodGrp4MenuService.getMenu({ prodgrp4_id: prodGrp4Id }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
